import { Box, makeStyles, TextField, TextFieldProps } from "@material-ui/core";
import * as React from "react";

import { fontFamilies } from "@/designTokens";

const useStyles = makeStyles({
  row: { display: "flex", justifyContent: "center", gap: 8, width: "100%" },
  cell: {
    width: 44,
    flexShrink: 0,
    "& .MuiOutlinedInput-root": { height: 52 },
    "& input": {
      padding: 0,
      textAlign: "center",
      fontSize: 24,
      fontWeight: 600,
      fontFamily: fontFamilies.number,
      height: 52,
    },
  },
});

export const CodeInput: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.row} role="group" aria-label="6桁の認証コード">
      {children}
    </Box>
  );
};

export const CodeInputCell: React.FC<TextFieldProps & { index: number }> = ({ index, inputProps, ...props }) => {
  const classes = useStyles();
  return (
    <TextField
      {...props}
      type="text"
      variant="outlined"
      className={classes.cell}
      inputProps={{
        "aria-label": `認証コード ${index + 1}桁目`,
        maxLength: index === 0 ? 10 : 1,
        pattern: "[0-9]*",
        inputMode: "numeric",
        autoComplete: index === 0 ? "one-time-code" : undefined,
        ...inputProps,
      }}
    />
  );
};
